import { createFileRoute } from "@tanstack/react-router";
import ProcureIntegrations from "lib/components/procure/ProcureIntegrations";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../../components/withAuthentication";

function ProcureIntegrationsPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Estimate: Integrations")}</title>
      </Head>
      <ProcureIntegrations path="integrations" />
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate/integrations/")({
  component: withAuthentication(ProcureIntegrationsPage, { products: ["procure"] }),
});
